import {api} from '../../utils/api'

export default {

    /**
     * load conditions
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    loadConditions({commit}, taskID) {
        return api.call(commit, 'get', '/api/conditions/'+taskID, null,  'SET_CONDITIONS');
    },

    /**
     * Update condition
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    updateCondition({commit}, payload) {
        return api.call(commit, 'patch', '/api/conditions/' + payload.id, payload, 'SET_CONDITIONS');
    },

    /**
     * Delete condition
     * @param commit
     * @returns {*|Promise|Promise<any>}
     */
    deleteCondition({commit}, payload) {
        return api.call(commit, 'delete', '/api/conditions/' + payload.id, null, 'DELETE_CONDITIONS');
    },

    /**
     * create new task condition
     * @param commit
     * @param payload
     * @returns {*|Promise|Promise<any>}
     */
    createCondition({commit}, payload) {
        // Create new field
        return api.call(commit, 'post', '/api/conditions/', payload, 'SET_CONDITIONS');
    },


}
